import actionCreatorFactory from 'typescript-fsa'
import { LoginFields } from '../../types'

const actionCreator = actionCreatorFactory()

export const updateFields = actionCreator<Partial<LoginFields>>('updateFields')

export const updateLoading = actionCreator<boolean>('updateLoading')
export const updateErrorMessage = actionCreator<string>('updateErrorMessage')
